import { SimCardOutputWithStatus } from './sim-card-output-with-status.model';


export class SimCardSelectByIdOutput implements ISimCardSelectByIdOutput {
    status!: number;
    message!: string;
    data!: SimCardOutputWithStatus;

    constructor(data?: ISimCardSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? SimCardOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SimCardSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISimCardSelectByIdOutput {
    status: number;
    message: string;
    data: SimCardOutputWithStatus;
}

